import { render, staticRenderFns } from "./houseRentDetail.vue?vue&type=template&id=61b2e03a&scoped=true&"
import script from "./houseRentDetail.vue?vue&type=script&lang=js&"
export * from "./houseRentDetail.vue?vue&type=script&lang=js&"
import style0 from "./houseRentDetail.vue?vue&type=style&index=0&id=61b2e03a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b2e03a",
  null
  
)

export default component.exports